<div *ngIf="webformUrl">
  <button color="primary" mat-button type="button" (click)="redirectToWebform()">
    Maak een melding
    <mat-icon>play_circle_outline</mat-icon>
  </button>
</div>
